/**
 * Catálogo de navegación compartido (sidebar → Mi Dashboard).
 * permissionKey: string | string[] (OR). null = siempre visible si autenticado.
 */
import { canAccessNmlBoard } from "../utils/nmlSuzhouCatalog";

export const NAV_SECTIONS = [
  { id: "widgets", labelKey: "myDashboard.sectionWidgets" },
  { id: "dashboard", labelKey: "sidebar.dashboard" },
  { id: "crm", labelKey: "sidebar.crm" },
  { id: "ai", labelKey: "sidebar.AISearch" },
  { id: "development", labelKey: "sidebar.development" },
  { id: "resources", labelKey: "sidebar.resources" },
  { id: "tracking", labelKey: "sidebar.tracking" },
  { id: "manufacturing", labelKey: "sidebar.manufacturing" },
  { id: "administration", labelKey: "sidebar.administration" },
  { id: "finance", labelKey: "sidebar.finance" },
  { id: "nmlFinance", labelKey: "sidebar.nmlFinance" },
  { id: "nmlSuzhou", labelKey: "sidebar.nmlSuzhou" },
  { id: "conocimiento", labelKey: "sidebar.BaseConocimiento" },
  { id: "tools", labelKey: "sidebar.tools" },
  { id: "user", labelKey: "sidebar.user" },
];

/** Widgets de datos curados (no son atajos de ruta). */
export const DATA_WIDGETS = [
  {
    id: "widget-my-tasks",
    type: "data",
    widgetKind: "myTasks",
    section: "widgets",
    labelKey: "myDashboard.widgetMyTasks",
    icon: "DvrOutlined",
    permissionKey: "Permiso_ToDoListGlobal",
    defaultSize: { w: 4, h: 3 },
  },
  {
    id: "widget-critical-path",
    type: "data",
    widgetKind: "criticalPath",
    section: "widgets",
    labelKey: "myDashboard.widgetCriticalPath",
    icon: "SportsCricketOutlined",
    permissionKey: ["Permiso_CriticalPathGlobal", "Permiso_CriticalPathUnido"],
    allowForProveedor: true,
    defaultSize: { w: 4, h: 3 },
  },
  {
    id: "widget-novedades",
    type: "data",
    widgetKind: "novedades",
    section: "widgets",
    labelKey: "myDashboard.widgetNovedades",
    icon: "AssessmentOutlined",
    permissionKey: "Permiso_Novedades",
    defaultSize: { w: 4, h: 3 },
  },
  {
    id: "widget-rfq-quotes",
    type: "data",
    widgetKind: "rfqQuotes",
    section: "widgets",
    labelKey: "myDashboard.widgetRfqQuotes",
    icon: "RequestQuoteOutlined",
    permissionKey: "Permiso_Estimates",
    defaultSize: { w: 4, h: 4 },
  },
];

/** Atajos a páginas del menú. */
export const SHORTCUT_ITEMS = [
  // Dashboard
  {
    id: "news",
    type: "shortcut",
    route: "/novedadesInsertar",
    section: "dashboard",
    labelKey: "sidebar.news",
    icon: "AssessmentOutlined",
    permissionKey: "Permiso_Novedades",
  },
  {
    id: "general",
    type: "shortcut",
    route: "/dashboard",
    section: "dashboard",
    labelKey: "sidebar.general",
    icon: "SpaceDashboardOutlined",
    permissionKey: "Permiso_Dashboard",
  },
  {
    id: "design-dashboard",
    type: "shortcut",
    route: "/dashboardDesigns",
    section: "dashboard",
    labelKey: "sidebar.design",
    icon: "DashboardCustomizeOutlined",
    permissionKey: "Permiso_DashboardDesigns",
  },
  {
    id: "ranking-ventas",
    type: "shortcut",
    route: "/rankingVentas",
    section: "dashboard",
    labelKey: "sidebar.rankingVentas",
    icon: "LeaderboardOutlined",
    permissionKey: "Permiso_RankingVenta",
  },
  {
    id: "organigrama",
    type: "shortcut",
    route: "/organigrama",
    section: "dashboard",
    labelKey: "sidebar.organigrama",
    icon: "AccountTreeOutlined",
    permissionKey: "Permiso_Organigrama",
  },
  // CRM
  {
    id: "clients",
    type: "shortcut",
    route: "/customers",
    section: "crm",
    labelKey: "sidebar.clients",
    icon: "People",
    permissionKey: "Permiso_Clients",
  },
  {
    id: "meetings",
    type: "shortcut",
    route: "/reuniones",
    section: "crm",
    labelKey: "sidebar.meetings",
    icon: "MicNoneOutlined",
    permissionKey: "Permiso_Reuniones",
  },
  {
    id: "kanban-clients",
    type: "shortcut",
    route: "/kanban",
    section: "crm",
    labelKey: "sidebar.kanbanClients",
    icon: "ViewKanbanOutlined",
    permissionKey: "Permiso_KambanClientes",
  },
  {
    id: "kanban-projects",
    type: "shortcut",
    route: "/kanbanproyectos",
    section: "crm",
    labelKey: "sidebar.kanbanProjects",
    icon: "AccountTreeOutlined",
    permissionKey: "Permiso_KambanProyectos",
    alsoMatch: ["/proyectos"],
  },
  {
    id: "tareas",
    type: "shortcut",
    route: "/tareas",
    section: "crm",
    labelKey: "sidebar.toDoListGlobal",
    icon: "DvrOutlined",
    permissionKey: "Permiso_ToDoListGlobal",
  },
  {
    id: "calendar",
    type: "shortcut",
    route: "/calendar",
    section: "crm",
    labelKey: "sidebar.taskCalendar",
    icon: "CalendarToday",
    permissionKey: "Permiso_Task",
  },
  // AI
  {
    id: "ai-search",
    type: "shortcut",
    route: "/aiSearch",
    section: "ai",
    labelKey: "sidebar.nasdesign",
    icon: "AutoAwesomeOutlined",
    permissionKey: "Permiso_Nasdesign",
  },
  {
    id: "presentaciones-ai",
    type: "shortcut",
    route: "/presentacionesSearch",
    section: "ai",
    labelKey: "sidebar.presentacionesAI",
    icon: "AutoAwesomeOutlined",
    permissionKey: "Permiso_PresentacionesAI",
  },
  {
    id: "skills-agentes",
    type: "shortcut",
    route: "/skills",
    section: "ai",
    labelKey: "sidebar.skills",
    icon: "AutoAwesomeOutlined",
    permissionKey: "Permiso_Skills",
  },
  {
    id: "skills-tareas",
    type: "shortcut",
    route: "/skills/tareas",
    section: "ai",
    labelKey: "sidebar.skillsTasks",
    icon: "AutoAwesomeOutlined",
    permissionKey: "Permiso_TareasAgentes",
  },
  // Development
  {
    id: "designs",
    type: "shortcut",
    route: "/producttree",
    section: "development",
    labelKey: "sidebar.designs",
    icon: "DrawOutlined",
    permissionKey: "Permiso_Designs",
  },
  {
    id: "samples",
    type: "shortcut",
    route: "/muestras",
    section: "development",
    labelKey: "sidebar.samples",
    icon: "DryCleaningOutlined",
    permissionKey: "Permiso_Samples",
  },
  {
    id: "lookbook",
    type: "shortcut",
    route: "/muestras1",
    section: "development",
    labelKey: "sidebar.lookbook",
    icon: "DryCleaningOutlined",
    permissionKey: "Permiso_Samples",
  },
  {
    id: "estimates",
    type: "shortcut",
    route: "/estimates",
    section: "development",
    labelKey: "sidebar.estimates",
    icon: "PriceCheck",
    permissionKey: "Permiso_Estimates",
  },
  {
    id: "articulos",
    type: "shortcut",
    route: "/articulosA3",
    section: "development",
    labelKey: "sidebar.articulosA3",
    icon: "Inventory2Outlined",
    permissionKey: "Permiso_Articulos",
  },
  {
    id: "produccion",
    type: "shortcut",
    route: "/produccionSummary",
    section: "development",
    labelKey: "sidebar.produccionSummary",
    icon: "LibraryBooksOutlined",
    permissionKey: "Permiso_PedidosA3",
  },
  {
    id: "logistica",
    type: "shortcut",
    route: "/gestionLogisticaPedidos",
    section: "development",
    labelKey: "sidebar.logisticaPedidos",
    icon: "LocalShippingOutlined",
    permissionKey: "Permiso_PedidosA3",
  },
  // Resources
  {
    id: "colores-muestras",
    type: "shortcut",
    route: "/colores-muestras",
    section: "resources",
    labelKey: "sidebar.coloresMuestras",
    icon: "ColorLensOutlined",
    permissionKey: "Permiso_Colores",
  },
  {
    id: "colores",
    type: "shortcut",
    route: "/colores",
    section: "resources",
    labelKey: "sidebar.colores",
    icon: "ColorLensOutlined",
    permissionKey: "Permiso_Colores",
  },
  {
    id: "materialoteca",
    type: "shortcut",
    route: "/materialoteca",
    section: "resources",
    labelKey: "sidebar.materialoteca",
    icon: "DesignServicesOutlined",
    permissionKey: "Permiso_Materialoteca",
  },
  {
    id: "ferias",
    type: "shortcut",
    route: "/ferias",
    section: "resources",
    labelKey: "sidebar.ferias",
    icon: "EventOutlined",
    permissionKey: "Permiso_Ferias",
  },
  {
    id: "suppliers",
    type: "shortcut",
    route: "/proveedores",
    section: "resources",
    labelKey: "sidebar.suppliers",
    icon: "PrecisionManufacturing",
    permissionKey: "Permiso_Suppliers",
  },
  {
    id: "factories",
    type: "shortcut",
    route: "/fabricas",
    section: "resources",
    labelKey: "sidebar.factories",
    icon: "FactoryOutlined",
    permissionKey: "Permiso_Suppliers",
  },
  // Tracking
  {
    id: "samples-location",
    type: "shortcut",
    route: "/muestrasUbicacion",
    section: "tracking",
    labelKey: "sidebar.samplesLocation",
    icon: "LocationOnOutlined",
    permissionKey: "Permiso_SamplesLocation",
  },
  {
    id: "samples-movement",
    type: "shortcut",
    route: "/muestrasMovimientoCamara",
    section: "tracking",
    labelKey: "sidebar.samplesMovement",
    icon: "VideoCameraFrontOutlined",
    permissionKey: "Permiso_SamplesLocation",
  },
  {
    id: "maletas",
    type: "shortcut",
    route: "/maletas",
    section: "tracking",
    labelKey: "sidebar.maletas",
    icon: "Inventory2Outlined",
    permissionKey: "Permiso_Maletash",
  },
  // Manufacturing
  {
    id: "cp-unitario",
    type: "shortcut",
    route: "/criticalPath",
    section: "manufacturing",
    labelKey: "sidebar.criticalPathUnitario",
    icon: "RoundaboutRightOutlined",
    permissionKey: "Permiso_CriticalPathUnido",
  },
  {
    id: "cp-global",
    type: "shortcut",
    route: "/criticalPathHorizontal",
    section: "manufacturing",
    labelKey: "sidebar.criticalPathGlobal",
    icon: "AlignHorizontalLeftOutlined",
    permissionKey: "Permiso_CriticalPathGlobal",
    allowForProveedor: true,
  },
  {
    id: "cp-gantt",
    type: "shortcut",
    route: "/criticalPathHorizontal1",
    section: "manufacturing",
    labelKey: "sidebar.criticalPathGant",
    icon: "SportsCricketOutlined",
    permissionKey: "Permiso_CriticalPathGlobal",
    allowForProveedor: true,
  },
  {
    id: "cp-notes",
    type: "shortcut",
    route: "/notasResumen",
    section: "manufacturing",
    labelKey: "sidebar.criticalPathNotes",
    icon: "ChecklistRtlOutlined",
    permissionKey: "Permiso_SeeAllNotes",
  },
  // Administration
  {
    id: "brands",
    type: "shortcut",
    route: "/gestionmarcas",
    section: "administration",
    labelKey: "sidebar.brands",
    icon: "People",
    permissionKey: "Permiso_Brands",
  },
  {
    id: "currency",
    type: "shortcut",
    route: "/currencyManager",
    section: "administration",
    labelKey: "sidebar.currencyManager",
    icon: "PriceCheck",
    permissionKey: "Permiso_CurrencyManager",
  },
  {
    id: "duties",
    type: "shortcut",
    route: "/dutties",
    section: "administration",
    labelKey: "sidebar.duties",
    icon: "AssuredWorkloadOutlined",
    permissionKey: "Permiso_Duties",
  },
  {
    id: "ddp",
    type: "shortcut",
    route: "/ddp-import-tarifas",
    section: "administration",
    labelKey: "sidebar.ddpImportTarifas",
    icon: "ImportExportOutlined",
    permissionKey: "Permiso_Duties",
  },
  {
    id: "cbm",
    type: "shortcut",
    route: "/volumenPrenda",
    section: "administration",
    labelKey: "sidebar.cbmGarment",
    icon: "LocalShippingOutlined",
    permissionKey: "Permiso_Cbm",
  },
  // Finance
  {
    id: "insights",
    type: "shortcut",
    route: "/insights",
    section: "finance",
    labelKey: "sidebar.insightsEjecutivos",
    icon: "InsightsOutlined",
    permissionKey: "Permiso_InsightsEjecutivos",
  },
  {
    id: "informes-ec",
    type: "shortcut",
    route: "/informes-ec",
    section: "finance",
    labelKey: "sidebar.informesEC",
    icon: "AssessmentOutlined",
    permissionKey: "Permiso_InformesEC",
  },
  {
    id: "pyg",
    type: "shortcut",
    route: "/pygdebug",
    section: "finance",
    labelKey: "sidebar.pyg",
    icon: "Euro",
    permissionKey: "Permiso_PyG",
    alsoMatch: ["/pyg"],
  },
  {
    id: "analitica-pyg",
    type: "shortcut",
    route: "/pyg-analitico/fusion",
    section: "finance",
    labelKey: "sidebar.analiticaPyg",
    icon: "BubbleChartOutlined",
    permissionKey: "Permiso_PyG",
    alsoMatch: ["/pyg-analitico"],
  },
  {
    id: "analitica-marca",
    type: "shortcut",
    route: "/pyg-analitico/fusion/por-marca",
    section: "finance",
    labelKey: "sidebar.analiticaPorMarca",
    icon: "BubbleChartOutlined",
    permissionKey: "Permiso_PyG",
  },
  {
    id: "cashflow",
    type: "shortcut",
    route: "/cashflow",
    section: "finance",
    labelKey: "sidebar.cashFlow",
    icon: "AutoGraphOutlined",
    permissionKey: "Permiso_CashFlow",
  },
  {
    id: "tpv",
    type: "shortcut",
    route: "/tpv",
    section: "finance",
    labelKey: "sidebar.tpv",
    icon: "StorefrontOutlined",
    permissionKey: "Permiso_Tpv",
  },
  {
    id: "pedidos-venta",
    type: "shortcut",
    route: "/pedidosVenta",
    section: "finance",
    labelKey: "sidebar.salesOrders",
    icon: "WaterfallChartOutlined",
    permissionKey: "Permiso_PedidosVenta",
  },
  {
    id: "ventas-totales",
    type: "shortcut",
    route: "/ventasTotales",
    section: "finance",
    labelKey: "sidebar.salesOverview",
    icon: "AutoModeOutlined",
    permissionKey: "Permiso_VentaTotal",
  },
  {
    id: "margenes",
    type: "shortcut",
    route: "/tablaReducida",
    section: "finance",
    labelKey: "sidebar.commissions",
    icon: "AccountBalanceWalletOutlined",
    permissionKey: "Permiso_MargenesVenta",
  },
  {
    id: "expenses",
    type: "shortcut",
    route: "/expenses",
    section: "finance",
    labelKey: "sidebar.expensesLegacy",
    icon: "PointOfSaleOutlined",
    permissionKey: "Permiso_Expenses",
  },
  {
    id: "expenses-user",
    type: "shortcut",
    route: "/expenses-user/notes",
    section: "finance",
    labelKey: "sidebar.expensesUser",
    icon: "PointOfSaleOutlined",
    permissionKey: "Permiso_ExpensesNew",
    alsoMatch: ["/expenses-user"],
  },
  {
    id: "nominas",
    type: "shortcut",
    route: "/nominas",
    section: "finance",
    labelKey: "sidebar.nominas",
    icon: "PaymentOutlined",
    permissionKey: "Permiso_Nominas",
  },
  {
    id: "nml-pyg",
    type: "shortcut",
    route: "/pyg-analitico/nml_spain",
    section: "nmlFinance",
    labelKey: "sidebar.nmlPyg",
    icon: "BubbleChartOutlined",
    permissionKey: "Permiso_NMLFinanzas",
  },
  {
    id: "nml-balance",
    type: "shortcut",
    route: "/balance-analitico/nml_spain",
    section: "nmlFinance",
    labelKey: "sidebar.nmlBalance",
    icon: "AccountBalanceOutlined",
    permissionKey: "Permiso_NMLFinanzas",
  },
  {
    id: "nml-suzhou-cp",
    type: "shortcut",
    route: "/nml/suzhou/critical-path",
    section: "nmlSuzhou",
    labelKey: "sidebar.nmlSuzhouCp",
    icon: "ViewWeekOutlined",
    permissionKey: ["Permiso_NmlSuzhou", "Permiso_NmlSuzhouCliente"],
    nmlBoard: "SUZHOU",
  },
  {
    id: "nml-turkey-cp",
    type: "shortcut",
    route: "/nml/turkey/critical-path",
    section: "nmlSuzhou",
    labelKey: "sidebar.nmlTurkeyCp",
    icon: "ViewWeekOutlined",
    permissionKey: ["Permiso_NmlTurkey", "Permiso_NmlSuzhouCliente"],
    nmlBoard: "TURKEY",
  },
  {
    id: "nml-guangzhou-cp",
    type: "shortcut",
    route: "/nml/guangzhou/critical-path",
    section: "nmlSuzhou",
    labelKey: "sidebar.nmlGuangzhouCp",
    icon: "ViewWeekOutlined",
    permissionKey: ["Permiso_NmlGuangzhou", "Permiso_NmlSuzhouCliente"],
    alsoMatch: ["/nml/wangzhou/critical-path"],
    nmlBoard: "GUANGZHOU",
  },
  // Conocimiento
  {
    id: "conocimiento",
    type: "shortcut",
    route: "/conocimiento",
    section: "conocimiento",
    labelKey: "sidebar.Conocimiento",
    icon: "SchoolOutlined",
    permissionKey: "Permiso_conocimiento",
  },
  {
    id: "crear-mensajes",
    type: "shortcut",
    route: "/crearMensajes",
    section: "conocimiento",
    labelKey: "sidebar.CrearMensajes",
    icon: "CampaignOutlined",
    permissionKey: "Permiso_CrearMensajes",
  },
  // Tools
  {
    id: "unibox",
    type: "shortcut",
    route: "/unibox",
    section: "tools",
    labelKey: "sidebar.unibox",
    icon: "InboxOutlined",
    permissionKey: "Permiso_Emails",
    alsoMatch: ["/emails"],
  },
  {
    id: "unibox-stats",
    type: "shortcut",
    route: "/unibox-stats",
    section: "tools",
    labelKey: "sidebar.uniboxStats",
    icon: "BarChartOutlined",
    permissionKey: "Permiso_UniboxStats",
  },
  {
    id: "booking",
    type: "shortcut",
    route: "/booking",
    section: "tools",
    labelKey: "sidebar.booking",
    icon: "VideoCameraFrontOutlined",
    permissionKey: "Permiso_Booking",
  },
  // User
  {
    id: "user-card",
    type: "shortcut",
    route: "/users",
    section: "user",
    labelKey: "sidebar.userVisitCard",
    icon: "ContactMailOutlined",
    permissionKey: "Permiso_UserVisitCard",
  },
  {
    id: "job-description",
    type: "shortcut",
    route: "/jobDescriptionPage",
    section: "user",
    labelKey: "sidebar.jobDescription",
    icon: "BadgeOutlined",
    permissionKey: "Permiso_JobDescription",
  },
  {
    id: "control-horario",
    type: "shortcut",
    route: "/control-horario",
    section: "user",
    labelKey: "sidebar.controlHorario",
    icon: "AccessTimeOutlined",
    permissionKey: ["Permiso_Fichaje", "Permiso_ControlHorario_RRHH"],
  },
  {
    id: "user-docs",
    type: "shortcut",
    route: "/user-documents",
    section: "user",
    labelKey: "sidebar.DocsUser",
    icon: "DescriptionOutlined",
    permissionKey: "Permiso_SubirDocsUser",
  },
  {
    id: "users-permissions",
    type: "shortcut",
    route: "/usersPermissions",
    section: "user",
    labelKey: "sidebar.usersPermissions",
    icon: "MiscellaneousServices",
    permissionKey: "Permiso_Users",
  },
];

export const NAV_CATALOG = [...DATA_WIDGETS, ...SHORTCUT_ITEMS];

export function hasCatalogPermission(
  item,
  permissions = {},
  { hasProveedorLimit = false } = {},
) {
  if (hasProveedorLimit && item.allowForProveedor) return true;
  if (item.nmlBoard) {
    return canAccessNmlBoard(permissions, item.nmlBoard);
  }
  const key = item.permissionKey;
  if (key == null) return true;
  if (Array.isArray(key)) return key.some((k) => !!permissions[k]);
  return !!permissions[key];
}

export function filterCatalogByPermissions(
  permissions = {},
  { hasProveedorLimit = false } = {},
) {
  return NAV_CATALOG.filter((item) =>
    hasCatalogPermission(item, permissions, { hasProveedorLimit }),
  );
}

export function getCatalogItemById(id) {
  return NAV_CATALOG.find((item) => item.id === id) || null;
}

const AUTH_ONLY_PATHS = [
  "/mi-dashboard",
  "/post-login",
  "/drawerInstrucciones",
];

function normalizePath(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path || "/";
}

function routePattern(route) {
  return normalizePath(String(route || "").replace(/\/:[^/]+\?/g, ""));
}

function routeToRegex(route) {
  const pattern = routePattern(route)
    .split("/")
    .map((seg) => {
      if (!seg) return "";
      if (seg.startsWith(":")) return "[^/]+";
      return seg.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    })
    .join("/");
  return new RegExp(`^${pattern}$`);
}

export function pathMatchesNavRoute(pathname, route) {
  const path = normalizePath(pathname);
  const base = routePattern(route);
  if (!base || base === "/") return path === "/";
  if (path === base) return true;
  if (path.startsWith(`${base}/`)) return true;
  return routeToRegex(route).test(path);
}

export function getNavItemByPath(pathname) {
  const path = normalizePath(pathname);
  let best = null;
  let bestLen = -1;
  for (const item of SHORTCUT_ITEMS) {
    const routes = [item.route, ...(item.alsoMatch || [])];
    for (const route of routes) {
      if (!pathMatchesNavRoute(path, route)) continue;
      const len = routePattern(route).length;
      if (len > bestLen) {
        best = item;
        bestLen = len;
      }
    }
  }
  return best;
}

function isAuthOnlyPath(pathname) {
  const path = normalizePath(pathname);
  return AUTH_ONLY_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
}

export function canAccessPath(
  pathname,
  permissions = {},
  { hasProveedorLimit = false } = {},
) {
  const item = getNavItemByPath(pathname);
  if (item) {
    return hasCatalogPermission(item, permissions, { hasProveedorLimit });
  }
  return isAuthOnlyPath(pathname);
}
